import React from 'react';
import { OrderStatusBadgeStyle, StatusBadgeProps } from '@helpers/Models';
import {
  OrderStatus,
  StatusBadgeStyles,
  orderListProductStatusLabels,
  orderListProductStatuses,
  orderListServiceStatusLabels,
  orderListServiceStatuses,
  productStatusLabels,
  productStatuses,
  serviceStatusLabels,
  serviceStatuses,
  newOrderStatusLabels,
  newOrderStatuses,
} from '@helpers/Constants';

// Unquie badge style for each status type
const StatusBadgeStyle: Record<
  string,
  Record<number, OrderStatusBadgeStyle>
> = {
  orderStatus: {
    [newOrderStatuses.NEW]: {
      label: newOrderStatusLabels[newOrderStatuses.NEW],
      ...StatusBadgeStyles.blue,
    },
    [newOrderStatuses.STARTED]: {
      label: newOrderStatusLabels[newOrderStatuses.STARTED],
      ...StatusBadgeStyles.brown,
    },
    [newOrderStatuses.PROCESSING]: {
      label: newOrderStatusLabels[newOrderStatuses.PROCESSING],
      ...StatusBadgeStyles.brown,
    },
    [newOrderStatuses.READY_TO_INVOICE]: {
      label: newOrderStatusLabels[newOrderStatuses.READY_TO_INVOICE],
      ...StatusBadgeStyles.cyan,
    },
    [newOrderStatuses.PARTIALLY_PICK_UP_READY]: {
      label: newOrderStatusLabels[newOrderStatuses.PARTIALLY_PICK_UP_READY],
      ...StatusBadgeStyles.blue,
    },
    [newOrderStatuses.PARTIALLY_PICKED_UP]: {
      label: newOrderStatusLabels[newOrderStatuses.PARTIALLY_PICKED_UP],
      ...StatusBadgeStyles.blue,
    },
    [newOrderStatuses.PICK_UP_READY]: {
      label: newOrderStatusLabels[newOrderStatuses.PICK_UP_READY],
      ...StatusBadgeStyles.green,
    },
    [newOrderStatuses.PICKED_UP]: {
      label: newOrderStatusLabels[newOrderStatuses.PICKED_UP],
      ...StatusBadgeStyles.green,
    },
  },
  orderServiceStatus: {
    [serviceStatuses.NEW]: {
      label: serviceStatusLabels[serviceStatuses.NEW],
      ...StatusBadgeStyles.blue,
    },
    [serviceStatuses.IN_PROGRESS]: {
      label: serviceStatusLabels[serviceStatuses.IN_PROGRESS],
      ...StatusBadgeStyles.brown,
    },
    [serviceStatuses.COMPLETE]: {
      label: serviceStatusLabels[serviceStatuses.COMPLETE],
      ...StatusBadgeStyles.green,
    },
    [serviceStatuses.INVOICED]: {
      label: serviceStatusLabels[serviceStatuses.INVOICED],
      ...StatusBadgeStyles.cyan,
    },
    [serviceStatuses.PAID]: {
      label: serviceStatusLabels[serviceStatuses.PAID],
      ...StatusBadgeStyles.green,
    },
  },
  orderProductStatus: {
    [productStatuses.NEW]: {
      label: productStatusLabels[productStatuses.NEW],
      ...StatusBadgeStyles.blue,
    },
    [productStatuses.IN_PROGRESS]: {
      label: productStatusLabels[productStatuses.IN_PROGRESS],
      ...StatusBadgeStyles.brown,
    },
    [productStatuses.COMPLETE]: {
      label: productStatusLabels[productStatuses.COMPLETE],
      ...StatusBadgeStyles.green,
    },
    [productStatuses.INVOICED]: {
      label: productStatusLabels[productStatuses.INVOICED],
      ...StatusBadgeStyles.cyan,
    },
    [productStatuses.PAID]: {
      label: productStatusLabels[productStatuses.PAID],
      ...StatusBadgeStyles.green,
    },
  },
  orderListServiceStatus: {
    [orderListServiceStatuses.NEW]: {
      label: orderListServiceStatusLabels[orderListServiceStatuses.NEW],
      ...StatusBadgeStyles.blue,
    },
    [orderListServiceStatuses.STARTED]: {
      label: orderListServiceStatusLabels[orderListServiceStatuses.STARTED],
      ...StatusBadgeStyles.brown,
    },
    [orderListServiceStatuses.PARTIALLY_COMPLETE]: {
      label:
        orderListServiceStatusLabels[
        orderListServiceStatuses.PARTIALLY_COMPLETE
        ],
      ...StatusBadgeStyles.cyan,
    },
    [orderListServiceStatuses.COMPLETED]: {
      label: orderListServiceStatusLabels[orderListServiceStatuses.COMPLETED],
      ...StatusBadgeStyles.green,
    },
  },
  orderListProductStatus: {
    [orderListProductStatuses.NEW]: {
      label: orderListProductStatusLabels[orderListProductStatuses.NEW],
      ...StatusBadgeStyles.blue,
    },
    [orderListProductStatuses.PROCESSING]: {
      label: orderListProductStatusLabels[orderListProductStatuses.PROCESSING],
      ...StatusBadgeStyles.brown,
    },
    [orderListProductStatuses.COMPLETED]: {
      label: orderListProductStatusLabels[orderListProductStatuses.COMPLETED],
      ...StatusBadgeStyles.green,
    },
  },
  serviceStatus: {
    [serviceStatuses.NEW]: {
      label: serviceStatusLabels[serviceStatuses.NEW],
      ...StatusBadgeStyles.blue,
    },
    [serviceStatuses.IN_PROGRESS]: {
      label: serviceStatusLabels[serviceStatuses.IN_PROGRESS],
      ...StatusBadgeStyles.brown,
    },
    [serviceStatuses.COMPLETE]: {
      label: serviceStatusLabels[serviceStatuses.COMPLETE],
      ...StatusBadgeStyles.green,
    },
    [serviceStatuses.INVOICED]: {
      label: serviceStatusLabels[serviceStatuses.INVOICED],
      ...StatusBadgeStyles.cyan,
    },
    [serviceStatuses.PAID]: {
      label: serviceStatusLabels[serviceStatuses.PAID],
      ...StatusBadgeStyles.green,
    },
  },
  productStatus: {
    [productStatuses.NEW]: {
      label: productStatusLabels[productStatuses.NEW],
      ...StatusBadgeStyles.blue,
    },
    [productStatuses.IN_PROGRESS]: {
      label: productStatusLabels[productStatuses.IN_PROGRESS],
      ...StatusBadgeStyles.brown,
    },
    [productStatuses.COMPLETE]: {
      label: productStatusLabels[productStatuses.COMPLETE],
      ...StatusBadgeStyles.green,
    },
    [productStatuses.INVOICED]: {
      label: productStatusLabels[productStatuses.INVOICED],
      ...StatusBadgeStyles.cyan,
    },
    [productStatuses.PAID]: {
      label: productStatusLabels[productStatuses.PAID],
      ...StatusBadgeStyles.green,
    },
  },
  invoiceStatus: {
    1: { label: OrderStatus.invoiced, ...StatusBadgeStyles.cyan },
    2: { label: OrderStatus.paid, ...StatusBadgeStyles.blue },
    3: { label: OrderStatus.pickedUp, ...StatusBadgeStyles.blue },
  },
  pickupStatus: {
    2: { label: 'Paid', ...StatusBadgeStyles.blue },
    3: { label: 'Picked Up', ...StatusBadgeStyles.green },
  },
  draftStatus: {
    0: { label: OrderStatus.draft, ...StatusBadgeStyles.green },
  },
  // Species status for Order details
  speciesStatus: {
    0: { label: OrderStatus.newOrder, ...StatusBadgeStyles.blue },
    1: { label: OrderStatus.inProgress, ...StatusBadgeStyles.brown },
    2: { label: OrderStatus.complete, ...StatusBadgeStyles.green },
  },
};

/**
 * `OrderStatusBadge` is a reusable badge component that displays a colored status label
 * based on the given status type and value. It is used for visualizing order,
 * service, product, or invoice status in a consistent UI format.
 *
 * @component
 * @param {Object} props - Component props
 * @param {number} props.status - The numeric status code (e.g. 0, 1, 2...) to determine the badge style.
 * @param {string} [props.message] - Optional custom label to override the default status label.
 * @param {string} props.type - The category of status. Must be one of: `"orderStatus"`, `"serviceStatus"`, `"productStatus"`, `"invoiceStatus"`.
 *
 * @returns {JSX.Element | null} A styled badge displaying the status, or `null` if the status/type combination is not recognized.
 *
 */
export const OrderStatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  message,
  type,
  className,
}) => {
  // type - orderStatus, serviceStatus, productStatus amd invoiceStatus
  // status - 0,1,2...
  const statusBadge = StatusBadgeStyle[type]?.[status];

  if (!statusBadge) return null;

  const { label, textColor, bgColor, borderColor } = statusBadge;
  // Text color, backgroud color and border color based on each status type and status
  const badgeStyle = `${textColor} ${bgColor} ${borderColor}`;

  return (
    <div
      className={`px-4 py-1 font-semibold rounded-full border-2 w-fit text-center ${badgeStyle} ${className ?? ''}`}
    >
      {message ?? label}
    </div>
  );
};
